import { LoadingSpinner } from './loading-spinner';

type CenteredLoadingProps = {
  text?: string;
};

export const CenteredLoading: React.FC<CenteredLoadingProps> = ({ text }) => (
  <div suppressHydrationWarning className="flex flex-col items-center justify-center w-full h-full">
    <LoadingSpinner size={24} />
    {text && <p className="mt-2 text-sm text-gray-500">{text}</p>}
  </div>
);

export default CenteredLoading;
